export const IB_BUSINESS_ID = "65e863894e18a579c452ec17";
export const CURRENCIES = [
  { label: "USD", value: "$" },
  { label: "GBP", value: "£" },
  { label: "AED", value: "د.إ" },
];
